import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./chat.module.css";
import axios from "axios";
import userAvatar from "../../../Assets/img/userProfile.png";

const ConversaionCard = ({ conv, user }) => {
  console.log("single conv", conv);
  const navigate = useNavigate();

  const getOneConversation = () => {
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/chat/get-messages", {
        admissioner_id: user._id,
        client_id: conv.client[0]._id,
      })
      .then((res) => {
        console.log(res);
        navigate(`/chat/${res.data[0].conversation_id}`, {
          state: {
            receiver: conv.client[0].name,
            conversation_id: res.data[0].conversation_id,
            myUser: user,
            members: res.data[1]?.members,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div
      className={styles.senderMessage}
      onClick={() => getOneConversation()}
    >
      <div className={styles.senderDetails}>
        <h3>{conv.client[0].name}</h3>
      </div>
      <div className={styles.senderImage}>
        <img src={userAvatar} alt="avatar" />
      </div>
    </div>
  );
};

export default ConversaionCard;